export const GET_ERRORS = "GET_ERRORS";
export const SET_ERROR = "SET_ERROR";
export const SESSION_EXPIRED = "SESSION_EXPIRED";
export const SESSION_OK = "SESSION_OK";
export const SESSION_CHECK_START = "SESSION_CHECK_START";
export const CLEAR_SESSION_EXPIRED = "CLEAR_SESSION_EXPIRED";
export const CLEAR_ERROR = "CLEAR_ERROR";

export const VERIFY_REQUEST = "VERIFY_REQUEST";
export const VERIFY_SUCCESS = "VERIFY_SUCCESS";
export const VERIFY_FAILURE = "VERIFY_FAILURE";

export const SIGNUP_USER = "SIGNUP_USER";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_EMAIL_FOR_VERIFICATION = "SET_EMAIL_FOR_VERIFICATION";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT = "LOGOUT";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const VERIFY_CODE_SUCCESS = "VERIFY_CODE_SUCCESS";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const CLEAR_MESSAGES = "CLEAR_MESSAGES";
export const FETCH_TEACHERS_REQUEST = "FETCH_TEACHERS_REQUEST";
export const FETCH_TEACHERS_SUCCESS = "FETCH_TEACHERS_SUCCESS";
export const FETCH_TEACHERS_FAILURE = "FETCH_TEACHERS_FAILURE";
export const FETCH_PENDING_COURSES_REQUEST = "FETCH_PENDING_COURSES_REQUEST";
export const FETCH_PENDING_COURSES_SUCCESS = "FETCH_PENDING_COURSES_SUCCESS";
export const FETCH_PENDING_COURSES_FAILURE = "FETCH_PENDING_COURSES_FAILURE";

export const FETCH_CATALOG_REQUEST = "FETCH_CATALOG_REQUEST";
export const FETCH_CATALOG_SUCCESS = "FETCH_CATALOG_SUCCESS";
export const FETCH_CATALOG_FAILURE = "FETCH_CATALOG_FAILURE";
export const FETCH_COURSE_DETAILS_REQUEST = "FETCH_COURSE_DETAILS_REQUEST";
export const FETCH_COURSE_DETAILS_SUCCESS = "FETCH_COURSE_DETAILS_SUCCESS";
export const FETCH_COURSE_DETAILS_FAILURE = "FETCH_COURSE_DETAILS_FAILURE";

export const FETCH_APPROVED_COURSES_REQUEST = "FETCH_APPROVED_COURSES_REQUEST";
export const FETCH_APPROVED_COURSES_SUCCESS = "FETCH_APPROVED_COURSES_SUCCESS";
export const FETCH_APPROVED_COURSES_FAILURE = "FETCH_APPROVED_COURSES_FAILURE";

export const APPROVE_COURSE_SUCCESS = "APPROVE_COURSE_SUCCESS";
export const APPROVE_COURSE_FAILURE = "APPROVE_COURSE_FAILURE";

export const MARK_COURSE_PENDING_SUCCESS = "MARK_COURSE_PENDING_SUCCESS";
export const MARK_COURSE_PENDING_FAILURE = "MARK_COURSE_PENDING_FAILURE";

export const FETCH_TEACHER_INFORMATION_SUCCESS =
  "FETCH_TEACHER_INFORMATION_SUCCESS";
export const FETCH_TEACHER_INFORMATION_FAILURE =
  "FETCH_TEACHER_INFORMATION_FAILURE";
export const UPDATE_TEACHER_PROFILE_ATTRIBUTES_REQUEST =
  "UPDATE_TEACHER_PROFILE_ATTRIBUTES_REQUEST";
export const UPDATE_TEACHER_PROFILE_ATTRIBUTES_SUCCESS =
  "UPDATE_TEACHER_PROFILE_ATTRIBUTES_SUCCESS";
export const UPDATE_TEACHER_PROFILE_ATTRIBUTES_FAILURE =
  "UPDATE_TEACHER_PROFILE_ATTRIBUTES_FAILURE";
export const SAVE_ADMIN_TEACHER_REQUEST = "SAVE_ADMIN_TEACHER_REQUEST";
export const SAVE_ADMIN_TEACHER_SUCCESS = "SAVE_ADMIN_TEACHER_SUCCESS";
export const SAVE_ADMIN_TEACHER_FAILURE = "SAVE_ADMIN_TEACHER_FAILURE";
export const UPLOAD_TEACHER_PROFILE_PICTURE_REQUEST =
  "UPLOAD_TEACHER_PROFILE_PICTURE_REQUEST";
export const UPLOAD_TEACHER_PROFILE_PICTURE_SUCCESS =
  "UPLOAD_TEACHER_PROFILE_PICTURE_SUCCESS";
export const UPLOAD_TEACHER_PROFILE_PICTURE_FAILURE =
  "UPLOAD_TEACHER_PROFILE_PICTURE_FAILURE";

export const FETCH_STUDENTS_REQUEST = "FETCH_STUDENTS_REQUEST";
export const FETCH_STUDENTS_SUCCESS = "FETCH_STUDENTS_SUCCESS";
export const FETCH_STUDENTS_FAILURE = "FETCH_STUDENTS_FAILURE";

export const FETCH_TEACHER_APPROVED_COURSES_REQUEST =
  "FETCH_TEACHER_APPROVED_COURSES_REQUEST";
export const FETCH_TEACHER_APPROVED_COURSES_SUCCESS =
  "FETCH_TEACHER_APPROVED_COURSES_SUCCESS";
export const FETCH_TEACHER_APPROVED_COURSES_FAILURE =
  "FETCH_TEACHER_APPROVED_COURSES_FAILURE";

export const FETCH_STUDENT_APPROVED_COURSES_REQUEST =
  "FETCH_STUDENT_APPROVED_COURSES_REQUEST";
export const FETCH_STUDENT_APPROVED_COURSES_SUCCESS =
  "FETCH_STUDENT_APPROVED_COURSES_SUCCESS";
export const FETCH_STUDENT_APPROVED_COURSES_FAILURE =
  "FETCH_STUDENT_APPROVED_COURSES_FAILURE";

export const ENROLL_FOR_FREE_REQUEST = "ENROLL_FOR_FREE_REQUEST";
export const ENROLL_FOR_FREE_SUCCESS = "ENROLL_FOR_FREE_SUCCESS";
export const ENROLL_FOR_FREE_FAILURE = "ENROLL_FOR_FREE_FAILURE";

export const FETCH_ENROLLED_COURSES_REQUEST = "FETCH_ENROLLED_COURSES_REQUEST";
export const FETCH_ENROLLED_COURSES_SUCCESS = "FETCH_ENROLLED_COURSES_SUCCESS";
export const FETCH_ENROLLED_COURSES_FAILURE = "FETCH_ENROLLED_COURSES_FAILURE";

export const FETCH_ENROLLED_COURSES_REQUEST_IDS =
  "FETCH_ENROLLED_COURSES_REQUEST_IDS";
export const FETCH_ENROLLED_COURSES_SUCCESS_IDS =
  "FETCH_ENROLLED_COURSES_SUCCESS_IDS";
export const FETCH_ENROLLED_COURSES_FAILURE_IDS =
  "FETCH_ENROLLED_COURSES_FAILURE_IDS";

export const FETCH_ENROLLED_COURSE_DETAILS_REQUEST =
  "FETCH_ENROLLED_COURSE_DETAILS_REQUEST";
export const FETCH_ENROLLED_COURSE_DETAILS_SUCCESS =
  "FETCH_ENROLLED_COURSE_DETAILS_SUCCESS";
export const FETCH_ENROLLED_COURSE_DETAILS_FAILURE =
  "FETCH_ENROLLED_COURSE_DETAILS_FAILURE";

export const RESET_STUDENT_DATA = "RESET_STUDENT_DATA";

export const FETCH_MANAGE_COURSES_REQUEST = "FETCH_MANAGE_COURSES_REQUEST";
export const FETCH_MANAGE_COURSES_SUCCESS = "FETCH_MANAGE_COURSES_SUCCESS";
export const FETCH_MANAGE_COURSES_FAILURE = "FETCH_MANAGE_COURSES_FAILURE";

export const FETCH_STUDENT_DETAILS_REQUEST = "FETCH_STUDENT_DETAILS_REQUEST";
export const FETCH_STUDENT_DETAILS_SUCCESS = "FETCH_STUDENT_DETAILS_SUCCESS";
export const FETCH_STUDENT_DETAILS_FAILURE = "FETCH_STUDENT_DETAILS_FAILURE";

// types.js

export const FETCH_LESSON_COURSE_TREE_REQUEST =
  "FETCH_LESSON_COURSE_TREE_REQUEST";
export const FETCH_LESSON_COURSE_TREE_SUCCESS =
  "FETCH_LESSON_COURSE_TREE_SUCCESS";
export const FETCH_LESSON_COURSE_TREE_FAILURE =
  "FETCH_LESSON_COURSE_TREE_FAILURE";
export const CLEAR_LESSON_COURSE_TREE = "CLEAR_LESSON_COURSE_TREE";

export const SET_TEACHER_PROFILE = "SET_TEACHER_PROFILE";
export const TEACHER_PROFILE_ERROR = "TEACHER_PROFILE_ERROR";

export const SET_TEACHER_APPLICATIONS = "SET_TEACHER_APPLICATIONS";
export const SET_LOADING = "SET_LOADING";

export const SET_CV_DOWNLOAD_URL = "SET_CV_DOWNLOAD_URL";

export const SET_MCQ_QUESTIONS = "SET_MCQ_QUESTIONS";
export const SET_MCQ_LOADING = "SET_MCQ_LOADING";
export const SET_LESEN_PASSAGE = "SET_LESEN_PASSAGE";

export const SET_AUDIO_QUESTIONS = "SET_AUDIO_QUESTIONS";

export const START_SESSION_SUCCESS = "START_SESSION_SUCCESS";
export const START_SESSION_FAIL = "START_SESSION_FAIL";

export const CHEATING_ATTEMPT_RESPONSE = "CHEATING_ATTEMPT_RESPONSE";
export const CHEATING_ATTEMPT_FAIL = "CHEATING_ATTEMPT_FAIL";

export const SET_BLACKLIST_STATUS = "SET_BLACKLIST_STATUS";
export const BLACKLIST_STATUS_FAIL = "BLACKLIST_STATUS_FAIL";

// --- STUDENT (Placement Test) ---
export const STUDENT_SET_MCQ_LOADING = "STUDENT_SET_MCQ_LOADING";
export const STUDENT_SET_MCQ_QUESTIONS = "STUDENT_SET_MCQ_QUESTIONS";
export const STUDENT_SET_MCQ_ERROR = "STUDENT_SET_MCQ_ERROR";

// NEW for Lesen
export const STUDENT_SET_LESEN_LOADING = "STUDENT_SET_LESEN_LOADING";
export const STUDENT_SET_LESEN_SUCCESS = "STUDENT_SET_LESEN_SUCCESS";
export const STUDENT_SET_LESEN_ERROR = "STUDENT_SET_LESEN_ERROR";

// NEW: Audio (Hören)
export const STUDENT_SET_AUDIO_LOADING = "STUDENT_SET_AUDIO_LOADING";
export const STUDENT_SET_AUDIO_SUCCESS = "STUDENT_SET_AUDIO_SUCCESS";
export const STUDENT_SET_AUDIO_ERROR = "STUDENT_SET_AUDIO_ERROR";

// src/redux/Actions/types.js
export const STUDENT_SET_MCQ_SELECTION = "STUDENT_SET_MCQ_SELECTION";
export const STUDENT_SET_LESEN_SELECTION = "STUDENT_SET_LESEN_SELECTION";
export const STUDENT_SET_AUDIO_SELECTION = "STUDENT_SET_AUDIO_SELECTION";
export const STUDENT_SET_SCHREIBEN_TEXT = "STUDENT_SET_SCHREIBEN_TEXT";
export const STUDENT_AUDIO_PLAY_INCREMENT = "STUDENT_AUDIO_PLAY_INCREMENT";
export const STUDENT_AUDIO_BLOCK = "STUDENT_AUDIO_BLOCK";
export const STUDENT_ANSWERS_RESET = "STUDENT_ANSWERS_RESET";

export const STUDENT_SET_STATUS_LOADING = "STUDENT_SET_STATUS_LOADING";
export const STUDENT_SET_STATUS_SUCCESS = "STUDENT_SET_STATUS_SUCCESS";
export const STUDENT_SET_STATUS_ERROR = "STUDENT_SET_STATUS_ERROR";

export const STUDENT_SET_BUNDLE_LOADING = "STUDENT_SET_BUNDLE_LOADING";
export const STUDENT_SET_BUNDLE_SUCCESS = "STUDENT_SET_BUNDLE_SUCCESS";
export const STUDENT_SET_BUNDLE_ERROR = "STUDENT_SET_BUNDLE_ERROR";

// Teacher Manager – Placement Results
export const TM_PL_RESULTS_FETCH_START = "TM_PL_RESULTS_FETCH_START";
export const TM_PL_RESULTS_FETCH_SUCCESS = "TM_PL_RESULTS_FETCH_SUCCESS";
export const TM_PL_RESULTS_FETCH_ERROR = "TM_PL_RESULTS_FETCH_ERROR";

export const TM_PL_FINALIZE_START = "TM_PL_FINALIZE_START";
export const TM_PL_FINALIZE_SUCCESS = "TM_PL_FINALIZE_SUCCESS";
export const TM_PL_FINALIZE_ERROR = "TM_PL_FINALIZE_ERROR";

// Enable retake for a student's placement test
export const TM_PL_ENABLE_RETAKE_START = "TM_PL_ENABLE_RETAKE_START";
export const TM_PL_ENABLE_RETAKE_SUCCESS = "TM_PL_ENABLE_RETAKE_SUCCESS";
export const TM_PL_ENABLE_RETAKE_ERROR = "TM_PL_ENABLE_RETAKE_ERROR";
